import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import login from "../login/Login";
import index from "../index"
import myAccount from "../account/myAccount";
Vue.use(Router)

// const index = () => import('../index.vue')
export default new Router({
  mode:"history",
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/myAccount',
      name: 'myAccount',
      component: myAccount
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{
        title:"login"
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js